import Circle from "./Circle";

class DistanceMarker {
  constructor(realPoint, customPoint, ddistance, index) {
    this.realPoint = realPoint;
    this.customPoint = customPoint;
    this.distance = ddistance;
    this.index = index;
  }

  getCircle(multiplyer) {
    return new Circle(this.customPoint, this.distance * multiplyer);
  }
}

export default DistanceMarker;
